import { themeColors } from '../../styles/theme'

export const styles = {
  titles: {
    color: themeColors.positive,
    fontSize: 20,
  },
  titleIcon: {
    color: themeColors.positive,
    position: 'relative',
    top: 5,
    marginRight: 10,
  },
  subtitles: {
    fontSize: 18,
    color: themeColors.energized,
    marginTop: 10,
    marginBottom: 10,
  },
  divider: {
    marginTop: 100,
    marginBottom: 50,
  },
  paper: {
    padding: 20,
    margin: 'auto',
    marginBottom: 30,
  },
  positive: {
    color: themeColors.positive,
  },
  tableTitle: {
    color: themeColors.secondary,
    fontSize: 14,
  },
  tableRow: {
    height: 'none',
    minHeight: '48px',
  },
  tableRight: {
    textOverflow: 'clip',
    whiteSpace: 'normal',
  },
  tableLeft: {
    fontWeight: 'bold',
  },
  question: {
    color: themeColors.energized,
    fontSize: 16,
  },
  answer: {
    fontStyle: 'italic',
    color: themeColors.neutral,
    fontSize: 16,
  },
  underPositive: {
    textDecoration: 'underline',
    textDecorationColor: themeColors.positive,
  },
  underSecondary: {
    textDecoration: 'underline',
    textDecorationColor: themeColors.secondary,
  },
}



// WEBPACK FOOTER //
// ./src/common/Infotext/Styles.js